import { render, staticRenderFns } from "./HandlingDeptTable.vue?vue&type=template&id=8fc60220&scoped=true"
import script from "./HandlingDeptTable.vue?vue&type=script&lang=js"
export * from "./HandlingDeptTable.vue?vue&type=script&lang=js"
import style0 from "./HandlingDeptTable.vue?vue&type=style&index=0&id=8fc60220&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc60220",
  null
  
)

export default component.exports